'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _googleMapReact = require('google-map-react');

var _googleMapReact2 = _interopRequireDefault(_googleMapReact);

var _InputTyping = require('../InputTyping/InputTyping');

var _InputTyping2 = _interopRequireDefault(_InputTyping);

var _Container = require('./components/Container');

var _Container2 = _interopRequireDefault(_Container);

var _Maps = require('./components/Maps');

var _Maps2 = _interopRequireDefault(_Maps);

var _Aside = require('./components/Aside');

var _Aside2 = _interopRequireDefault(_Aside);

var _HomeMarker = require('./components/HomeMarker');

var _HomeMarker2 = _interopRequireDefault(_HomeMarker);

var _Marker = require('./components/Marker');

var _Marker2 = _interopRequireDefault(_Marker);

var _SelectedVehicle = require('./components/SelectedVehicle');

var _SelectedVehicle2 = _interopRequireDefault(_SelectedVehicle);

var _VehicleList = require('./components/VehicleList');

var _VehicleList2 = _interopRequireDefault(_VehicleList);

var _VehicleScroll = require('./components/VehicleScroll');

var _VehicleScroll2 = _interopRequireDefault(_VehicleScroll);

var _InputContainer = require('./components/InputContainer');

var _InputContainer2 = _interopRequireDefault(_InputContainer);

var _Vehicle = require('./components/Vehicle');

var _Vehicle2 = _interopRequireDefault(_Vehicle);

var _NoData = require('./components/NoData');

var _NoData2 = _interopRequireDefault(_NoData);

var _Loader = require('./components/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components


var VehicleTracker = function (_Component) {
  _inherits(VehicleTracker, _Component);

  function VehicleTracker() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, VehicleTracker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VehicleTracker.__proto__ || Object.getPrototypeOf(VehicleTracker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      vehicles: [],
      filteredVehicles: [],
      markerVehicles: [],
      selected: '',
      filter: ''
    }, _this.initVehicles = function () {
      var selected = _this.state.selected;
      var vehicles = _this.props.vehicles;

      var filteredVehicles = _this.vehicleList({
        vehicles: vehicles
      });

      var markerVehicles = !!selected && ![].concat(_toConsumableArray(filteredVehicles)).find(function (v) {
        return _this.isSame(v.id, selected);
      }) ? [].concat(_toConsumableArray(filteredVehicles), [_this.selectedVehicle()]) : [].concat(_toConsumableArray(filteredVehicles));

      _this.setState({
        vehicles: vehicles,
        filteredVehicles: filteredVehicles,
        markerVehicles: markerVehicles
      });
    }, _this.isSame = function (one, two) {
      return '' + one === '' + two;
    }, _this.toggleSelect = function (id) {
      return _this.setState({
        selected: _this.state.selected === id ? '' : '' + id
      });
    }, _this.onSelect = function (id) {
      return _this.setState({
        selected: '' + id
      });
    }, _this.onDeselect = function () {
      return _this.setState({
        selected: ''
      });
    }, _this.onMapClick = function (id) {
      if (id === 'home' || !id) return;

      _this.toggleSelect(id);
    }, _this.onFilter = function (filter) {
      var selected = _this.state.selected;

      var filteredVehicles = _this.vehicleList({
        filter: filter
      });

      var markerVehicles = !!selected && ![].concat(_toConsumableArray(filteredVehicles)).find(function (v) {
        return _this.isSame(v.id, selected);
      }) ? [].concat(_toConsumableArray(filteredVehicles), [_this.selectedVehicle()]) : [].concat(_toConsumableArray(filteredVehicles));

      _this.setState({
        filter: filter,
        filteredVehicles: filteredVehicles,
        markerVehicles: markerVehicles
      });
    }, _this.vehicleList = function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$vehicles = _ref2.vehicles,
          vehicles = _ref2$vehicles === undefined ? _this.state.vehicles : _ref2$vehicles,
          _ref2$filter = _ref2.filter,
          filter = _ref2$filter === undefined ? _this.state.filter : _ref2$filter,
          _ref2$selected = _ref2.selected,
          selected = _ref2$selected === undefined ? _this.state.selected : _ref2$selected;

      var filters = _this.props.filters;
      if (!filter) return [].concat(_toConsumableArray(vehicles));
      var flt = filter.toLowerCase();

      var defaultFilter = function defaultFilter(_ref3) {
        var vehicle = _ref3.vehicle;
        return [vehicle.svid, vehicle.driver].some(function (d) {
          return d.toLowerCase().includes(flt);
        });
      };

      var selectedVehicle = !!selected ? _this.selectedVehicle() : null;
      var customFilter = [].concat(_toConsumableArray(filters)).find(function (f) {
        return f.trigger({
          filter: flt,
          selected: selectedVehicle
        });
      });
      return [].concat(_toConsumableArray(vehicles)).filter(function (vehicle) {
        var parameters = {
          vehicle: vehicle,
          filter: flt,
          selected: selectedVehicle
        };
        return !!customFilter ? customFilter.filter(parameters) : defaultFilter(parameters);
      });
    }, _this.selectedVehicle = function () {
      var selected = _this.state.selected;
      if (!selected) return {};
      return [].concat(_toConsumableArray(_this.state.vehicles)).find(function (_ref4) {
        var id = _ref4.id;
        return _this.isSame(id, _this.state.selected);
      }) || {};
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(VehicleTracker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initVehicles();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.lastUpdate === this.props.lastUpdate && prevState.selected === this.state.selected) return;
      this.initVehicles();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          center = _props.center,
          zoom = _props.zoom,
          home = _props.home,
          loading = _props.loading;
      var _state = this.state,
          selected = _state.selected,
          filter = _state.filter,
          filteredVehicles = _state.filteredVehicles,
          markerVehicles = _state.markerVehicles;
      return _react2.default.createElement(_Container2.default, null, _react2.default.createElement(_Maps2.default, null, _react2.default.createElement(_googleMapReact2.default, {
        defaultZoom: zoom,
        defaultCenter: center,
        onChildClick: this.onMapClick,
        bootstrapURLKeys: {
          key: 'AIzaSyD1fDAIat81Ta6fmx-h3DspQWy5pt9vcIM'
        }
      }, _react2.default.createElement(_HomeMarker2.default, _extends({}, home, {
        id: 'home'
      })), markerVehicles.map(function (vehicle) {
        return _react2.default.createElement(_Marker2.default, _extends({
          key: vehicle.id
        }, vehicle, {
          selected: _this2.isSame(vehicle.id, selected),
          onClose: _this2.onDeselect
        }));
      }))), _react2.default.createElement(_Aside2.default, null, _react2.default.createElement(_VehicleList2.default, null, _react2.default.createElement(_InputContainer2.default, null, _react2.default.createElement(_InputTyping2.default, {
        value: filter,
        onChange: this.onFilter,
        size: 'large',
        preIcon: 'search1',
        placeholder: 'search',
        treshold: 300,
        noBorder: true
      })), _react2.default.createElement(_VehicleScroll2.default, null, !filteredVehicles.length && _react2.default.createElement(_NoData2.default, null, 'No data found'), filteredVehicles.map(function (vehicle, index) {
        return _react2.default.createElement(_Vehicle2.default, _extends({
          key: vehicle.id
        }, vehicle, {
          odd: index % 2 === 0,
          onSelect: function onSelect() {
            return _this2.toggleSelect('' + vehicle.id);
          }
        }));
      })))), !!selected && _react2.default.createElement(_SelectedVehicle2.default, _extends({}, this.selectedVehicle(), {
        onClose: this.onDeselect
      })), _react2.default.createElement(_Loader2.default, {
        visible: loading
      }));
    }
  }]);

  return VehicleTracker;
}(_react.Component);

VehicleTracker.propTypes = {
  vehicles: _propTypes2.default.array,
  loading: _propTypes2.default.bool,
  lastUpdate: _propTypes2.default.number,
  center: _propTypes2.default.array,
  home: _propTypes2.default.shape({
    lat: _propTypes2.default.number.isRequired,
    lng: _propTypes2.default.number.isRequired
  }),
  filters: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    trigger: _propTypes2.default.func.isRequired,
    filter: _propTypes2.default.func.isRequired
  })),
  zoom: _propTypes2.default.number
};
VehicleTracker.defaultProps = {
  vehicles: [],
  loading: false,
  lastUpdate: 0,
  center: [40.75094740215093, -73.95362888822002],
  home: {
    lat: 40.751171,
    lng: -73.940276
  },
  zoom: 10,
  filters: []
};
exports.default = VehicleTracker;